import { LitElement, html, css } from 'lit'
import { customElement } from 'lit/decorators.js'

const STYLES = css`
:host {
 }
 
 div#WLTR_controlIcon, div#WLTR_popBody, div#WLTR_popBody * {
    font-family: 'Poppins', sans-serif; font-style: normal; font-weight: 500; font-size: 14px; line-height: 16px; margin:0; padding:0;border:0; outline:0; vertical-align:baseline; background:transparent;text-decoration: none;
  }

`
@customElement('cp-template')
export class ControlPanelTemplate extends LitElement {
    static styles = STYLES

    protected render() {
        return html`
       <slot></slot>
        `;
    }
}


